import React, { Fragment, Component } from "react";
import { observer, inject } from "mobx-react";
import { Grid, Button, Typography } from "@material-ui/core";
import moment from "moment";

import Loading from "../../../components/loadingSpinner/Loading";
import GigPromotionCard from "./GigPromotionCard";

const ITEMS_PER_PAGE = 15;

@inject("gigPromotionStore")
@observer
class PendingGigPromotions extends Component {
    state = { isLoading: true, total: null };
    _isMounted = false;

    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const { startDate, endDate, venueIds, currentPage, reloadKey, searchQuery } = this.props;
        const filtersChanged =
            prevProps.startDate !== startDate ||
            prevProps.endDate !== endDate ||
            JSON.stringify(prevProps.venueIds) !== JSON.stringify(venueIds) ||
            prevProps.searchQuery !== searchQuery;
        const pageChanged = prevProps.currentPage !== currentPage;
        const reloaded = prevProps.reloadKey !== reloadKey;

        if (filtersChanged || pageChanged || reloaded) {
            this.fetchData();
        }
    }

    fetchData() {
        const { startDate, endDate, venueIds, currentPage = 1, searchQuery } = this.props;
        this.setState({ isLoading: true });
        this.props.gigPromotionStore.getPendingFiltered({
            dateFrom: startDate ? moment(startDate).format("YYYY-MM-DD") : undefined,
            dateTo: endDate ? moment(endDate).format("YYYY-MM-DD") : undefined,
            venueIds: venueIds || [],
            page: currentPage,
            take: ITEMS_PER_PAGE,
            search: searchQuery || undefined,
        }).then(({ total }) => {
            if (this._isMounted) this.setState({ isLoading: false, total });
        }).catch(() => {
            if (this._isMounted) this.setState({ isLoading: false });
        });
    }

    handleCancelGigPromotion = gigPromotion => {
        this.setState({ isLoading: true });
        return this.props.gigPromotionStore.removeGigPromotion(gigPromotion.id).then(() => {
            if (this._isMounted) this.setState({ isLoading: false });
            this.fetchData();
        });
    };

    render() {
        const { isLoading, total } = this.state;
        const { currentPage = 1, onPageChange } = this.props;
        const { pendingGigPromotions } = this.props.gigPromotionStore;

        const items = pendingGigPromotions.slice();
        const hasKnownTotal = total !== null;
        const totalPages = hasKnownTotal ? Math.max(1, Math.ceil(total / ITEMS_PER_PAGE)) : null;
        const hasMore = hasKnownTotal ? currentPage < totalPages : items.length === ITEMS_PER_PAGE;
        const showPagination = currentPage > 1 || hasMore;

        return (
            <Fragment>
                <Grid container spacing={16} style={{ position: "relative", minHeight: 300 }}>
                    <Loading showed={isLoading} />
                    {!isLoading && items.length === 0 ? (
                        <Grid item xs={12}>
                            <Typography variant="body1" style={{ color: "rgba(0,0,0,0.45)", textAlign: "center", padding: "40px 0" }}>
                                No draft promotions found for the selected filters.
                            </Typography>
                        </Grid>
                    ) : (
                        items.map(gigPromotion => (
                            <Grid item xs={12} sm={6} md={4} key={gigPromotion.id}>
                                <GigPromotionCard
                                    gigPromotion={gigPromotion}
                                    cancelGigPromotionHandler={() => this.handleCancelGigPromotion(gigPromotion)}
                                />
                            </Grid>
                        ))
                    )}
                </Grid>
                {showPagination && (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 16, marginTop: 24, padding: "8px 0" }}>
                        <Button size="small" variant="outlined" disabled={currentPage <= 1} onClick={() => onPageChange && onPageChange(currentPage - 1)} style={{ borderColor: "#ff0c9c", color: "#ff0c9c", textTransform: "none" }}>
                            ‹ Previous
                        </Button>
                        <Typography variant="body2" style={{ fontWeight: 500, color: "#EEEEEE" }}>
                            {hasKnownTotal
                                ? `Page ${currentPage} of ${totalPages} · ${total} result${total !== 1 ? "s" : ""}`
                                : `Page ${currentPage}`}
                        </Typography>
                        <Button size="small" variant="outlined" disabled={!hasMore} onClick={() => onPageChange && onPageChange(currentPage + 1)} style={{ borderColor: "#ff0c9c", color: "#ff0c9c", textTransform: "none" }}>
                            Next ›
                        </Button>
                    </div>
                )}
            </Fragment>
        );
    }
}

export default PendingGigPromotions;
